/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAward: {
  name: 'award';
  data: string;
} = {
  name: 'award',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM8 .5a4.5 4.5 0 0 0-2.985 7.868L2.533 14.82a.5.5 0 0 0 .653.644L8 13.54l4.814 1.925a.5.5 0 0 0 .653-.644l-2.482-6.452A4.5 4.5 0 0 0 8 .5Zm2.14 8.46A4.48 4.48 0 0 1 8 9.5a4.48 4.48 0 0 1-2.14-.54l-1.982 5.15 3.936-1.574a.5.5 0 0 1 .372 0l3.936 1.574-1.981-5.15Z" fill="currentColor"/></svg>`,
};
